import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { DBCustomerOrderStatusEnum } from '@tyrio/dto';

interface WorkOrderStatusSelectorProps {
  selectedStatus: string | null;
  onStatusChange: (status: string | null) => void;
}

const ORDER_STATUSES = [
  { value: DBCustomerOrderStatusEnum.NEW, label: 'New' },
  { value: DBCustomerOrderStatusEnum.PENDING, label: 'Pending' },
  { value: DBCustomerOrderStatusEnum.ORDERED, label: 'Ordered' },
  { value: DBCustomerOrderStatusEnum.IN_PROCESS, label: 'In Process' },
  { value: DBCustomerOrderStatusEnum.ON_HOLD, label: 'On Hold' },
  { value: DBCustomerOrderStatusEnum.READY_FOR_SHIPPING, label: 'Ready for Shipping' },
  { value: DBCustomerOrderStatusEnum.SHIPPED, label: 'Shipped' },
  { value: DBCustomerOrderStatusEnum.DELIVERED, label: 'Delivered' },
  { value: DBCustomerOrderStatusEnum.COLLECTED, label: 'Collected' },
  { value: DBCustomerOrderStatusEnum.FITTED, label: 'Fitted' },
  { value: DBCustomerOrderStatusEnum.CANCELLED, label: 'Cancelled' },
  { value: DBCustomerOrderStatusEnum.RETURN_REQUESTED, label: 'Return Requested' },
  { value: DBCustomerOrderStatusEnum.RETURNED, label: 'Returned' },
  { value: DBCustomerOrderStatusEnum.EXCHANGE_REQUESTED, label: 'Exchange Requested' },
  { value: DBCustomerOrderStatusEnum.EXCHANGED, label: 'Exchanged' },
  { value: DBCustomerOrderStatusEnum.DROPSHIPPING, label: 'Dropshipping' },
];

const WorkOrderStatusSelector: React.FC<WorkOrderStatusSelectorProps> = ({
  selectedStatus,
  onStatusChange,
}) => {
  return (
    <FormControl fullWidth sx={{ minWidth: 200 }}>
      <InputLabel id="status-selector-label">Order Status</InputLabel>
      <Select
        labelId="status-selector-label"
        id="status-selector"
        value={selectedStatus || ''}
        label="Order Status"
        onChange={(event) => {
          const value = event.target.value;
          onStatusChange(value === '' ? null : value);
        }}
      >
        <MenuItem value="">
          <em>All Statuses</em>
        </MenuItem>
        {ORDER_STATUSES.map((status) => (
          <MenuItem key={status.value} value={status.value}>
            {status.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default WorkOrderStatusSelector; 